import { tempMeeApi as api, getAuthHeaders } from '~/services/api';

const skipJobAdjustment = async (jobId: string): Promise<void> => {
  const headers = await getAuthHeaders();

  await api.post(
    `/jobs/${jobId}/skip-adjustment`,
    {},
    {
      headers: { ...headers },
    },
  );
};

export const jobAdjustmentApi = {
  skipJobAdjustment,
};
